<template>

    <th @click="handleClick" :style="width!='' ? {width:`${width}`}:''" class="qb-sticky">
        {{ text }}
        <span v-if="sortType == 'ASC'" class="material-icons sm-size">keyboard_arrow_up</span>
        <span v-else class="material-icons sm-size">keyboard_arrow_down</span>
    </th>

</template>

<script>
export default {
    props:{
        text:{
            type:String,
            default:'Header'
        },
        column:{
            type:String,
            default:'ASC'
        },
        width:{
            type:String,
            deault:''
        }   
    },
    data:() => ({
        sortType:'ASC'
    }),
    methods:{
        handleClick(){
            this.sortType = this.sortType == 'ASC' ? 'DESC':'ASC';
            let arraySortBy = this.column.split(',');
            let arraySort = [this.sortType]
            if(arraySortBy.length > 1){
                for (let index = 0; index < arraySortBy.length; index++) {
                    arraySort[index] = this.sortType
                }
            }
            let sortParams={
                sort:arraySort,
                sortBy:arraySortBy
            }
            this.$emit('sort',sortParams);
        }
    }
}
</script>

<style>
.sm-size {
  font-size: 14px;
}
</style>